import { render, staticRenderFns } from "./DeleteEmployeeDialog.vue?vue&type=template&id=797fc4e0&scoped=true"
import script from "./DeleteEmployeeDialog.vue?vue&type=script&lang=js"
export * from "./DeleteEmployeeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797fc4e0",
  null
  
)

export default component.exports